import * as React from 'react';
import { Drawer, DrawerContent, DrawerItem } from '@progress/kendo-react-layout';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu'
import AuthService from "../services/auth.service";
import { useTranslation } from "react-i18next";

const CustomItem = (props) => {
    const { visible, ...others } = props;
    const arrowDir = props['data-expanded'] ? 'k-i-arrow-chevron-down' : 'k-i-arrow-chevron-right';

    return (
        <React.Fragment>
            {props.visible === false ? null :
                <DrawerItem {...others} >
                    <span className={'k-icon ' + props.icon} />
                    <p className={'k-item-text'}></p> {props.text}
                    {props['data-expanded'] !== undefined && <span className={"k-icon " + arrowDir} style={{ position: "absolute", right: 5 }} />}
                </DrawerItem>}
        </React.Fragment>
    );
};

function DrawerRouterContainer(props) {

    const { t } = useTranslation();

    const [items, setItems] = React.useState([]);

    React.useEffect(() => {

        var user = AuthService.getCurrentUser();
        var itemsMenu = [];

        if (user) {

            itemsMenu = [
                { text: t("Home_Title"), id: 0, icon: 'k-i-home', route: '/' },
                { text: t("RawMaterials_Title"), id: 1, icon: 'k-i-shape-circle', 'data-expanded': false },
                { text: t("RawMaterials_List_Title"), id: 2, parentId: 1, route: '/RawMaterials' },
                { text: t("RawMaterials_Group_Title"), id: 3, parentId: 1, route: '/RawMaterialGroups' },
                { separator: true },
                { text: t("AnalyticalComponents_Title"), id: 4, icon: 'k-i-filter', 'data-expanded': false },
                { text: t("AnalyticalComponents_List_Title"), id: 5, parentId: 4, route: '/AnalyticComponents' },
                //{ text: t("AnalyticalComponents_Group_Title"), id: 6, parentId: 4 },
                { separator: true },
                { text: t("Additives_Title"), id: 6, icon: 'k-i-sum', 'data-expanded': false },
                { text: t("Additives_List_Title"), id: 7, parentId: 6, route: '/Additives' },
                { text: t("AdditiveCategories_List_Title"), id: 8, parentId: 6, route: '/AdditiveCategories' },
                { text: t("FunctionalGroups_List_Title"), id: 9, parentId: 6, route: '/FunctionalGroups' }
                //{ text: t("Additives_FunctionalGroups_Title"), id: 9, parentId: 7, route: '/Additives' },
                //{ text: t("Additives_Categories_Title"), id: 10, parentId: 7, route: '/Additives' }
            ];

        }
        else {
            itemsMenu = [
                { text: t("Home_Title"), id: 0, icon: 'k-i-home', route: '/' }
            ];

        }

        setItems(itemsMenu);

    }, [t]);




    const [state, setState] = React.useState({ drawerExpanded: window.innerWidth > 768, isSmallerScreen: window.innerWidth < 768 });

    const handleClick = (event) => {
        event.preventDefault();
        setState({ drawerExpanded: !state.drawerExpanded, isSmallerScreen: state.isSmallerScreen });
    };

    const onSelect = (ev) => {
        const currentItem = ev.itemTarget.props;
        const isParent = currentItem['data-expanded'] !== undefined;
        const nextExpanded = !currentItem['data-expanded'];

        const newData = items.map((item) => {
            const { selected, 'data-expanded': currentExpanded, id, ...others } = item;
            const isCurrentItem = currentItem.id === id;
            return {
                selected: isCurrentItem,
                'data-expanded': isCurrentItem && isParent ? nextExpanded : currentExpanded,
                id,
                ...others
            };
        });

        if (!isParent && (window.innerWidth < 768))
            setState({ drawerExpanded: !state.drawerExpanded, isSmallerScreen: state.isSmallerScreen });

        setItems(newData);
        props.history.push(ev.itemTarget.props.route);
    }


    const data = items.map((item) => {
        const { parentId, ...others } = item;
        if (parentId !== undefined) {
            const parent = items.find(parent => parent.id === parentId)
            return {
                ...others,
                visible: parent['data-expanded']
            };
        }
        return item;
    });

    return (
        <div>
            <NavMenu onButtonClick={handleClick} />
            <Drawer
                expanded={state.drawerExpanded}
                mode={state.isSmallerScreen ? 'overlay' : 'push'}
                // mini={true}
                style={{ height: "100vh" }}
                items={data}
                position='start'
                item={CustomItem}
                onSelect={onSelect}
            >
                <DrawerContent>
                    <div>
                        <Container>
                            {props.children}
                        </Container>
                    </div>
                </DrawerContent>
            </Drawer>
        </div >
    );

};

export default withRouter(DrawerRouterContainer);
